let _initProto, _initClass, _init_content, _init_extra_content, _init_placement, _init_extra_placement, _init_delay, _init_extra_delay, _init_tooltipTarget, _init_extra_tooltipTarget;
function _applyDecs(e, t, n, r, o, i) { var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length; function g(t, n, r) { return function (o, i) { n && (i = o, o = e); for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []); return r ? i : o; }; } function b(e, t, n, r) { if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined")); return e; } function applyDec(e, t, n, r, o, i, u, s, f, l, p) { function d(e) { if (!p(e)) throw new TypeError("Attempted to access private element on non-instance"); } var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o; function I(t, n, r) { return function (o, i) { return n && (i = o, o = e), r && r(o), P[t].call(o, i); }; } if (!w) { var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value"; if (f ? (l || D ? P = { get: _setFunctionName(function () { return v(this); }, r, "get"), set: function (e) { t[4](this, e); } } : P[F] = v, l || _setFunctionName(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) { if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet"); y[+s][r] = o < 3 ? 1 : o; } } for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) { var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = { kind: ["field", "accessor", "method", "getter", "setter", "class"][o], name: r, metadata: a, addInitializer: function (e, t) { if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished"); b(t, "An initializer", "be", !0), i.push(t); }.bind(null, A) }; if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function (e) { return r in e; } }, j || (c.get = f ? E ? function (e) { return d(e), P.value; } : I("get", 0, d) : function (e) { return e[r]; }), E || S || (c.set = f ? I("set", 0, d) : function (e, t) { e[r] = t; }), N = T.call(z, D ? { get: P.get, set: P.set } : P[F], H), A.v = 1, D) { if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined"); } else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N); } return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N; } function w(e) { return m(e, d, { configurable: !0, enumerable: !0, value: a }); } return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function (e) { e && f.push(g(e)); }, p = function (t, r) { for (var i = 0; i < n.length; i++) { var a = n[i], c = a[1], l = 7 & c; if ((8 & c) == t && !l == r) { var p = a[2], d = !!a[3], m = 16 & c; applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function (t) { return _checkInRHS(t) === e; } : o); } } }, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), { e: c, get c() { var n = []; return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)]; } }; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _setFunctionName(e, t, n) { "symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : ""); try { Object.defineProperty(e, "name", { configurable: !0, value: n ? n + " " + t : t }); } catch (e) {} return e; }
function _checkInRHS(e) { if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null")); return e; }
import { jsx, jsxs } from "@ecopages/jsx/jsx-runtime";
import { RadiantElement, bound, customElement, onEvent, onUpdated, prop, query } from "@ecopages/radiant";
import { findFirstFocusableCandidate } from "@/lib/focusable-elements";
import { applyFloatingPosition, attachFloating } from "../shared/floating-position";
const TOOLTIP_GAP = 8;
let _RuiTooltip;
class RuiTooltip extends RadiantElement {
  static {
    ({
      e: [_init_content, _init_extra_content, _init_placement, _init_extra_placement, _init_delay, _init_extra_delay, _init_tooltipTarget, _init_extra_tooltipTarget, _initProto],
      c: [_RuiTooltip, _initClass]
    } = _applyDecs(this, [customElement("rui-tooltip")], [[prop({
      type: String,
      defaultValue: ""
    }), 0, "content"], [prop({
      type: String,
      defaultValue: "top"
    }), 0, "placement"], [prop({
      type: Number,
      defaultValue: 200
    }), 0, "delay"], [query({
      ref: "tooltip"
    }), 0, "tooltipTarget"], [onUpdated(["content", "placement"]), 2, "onDescribedPropsUpdated"], [onEvent({
      document: true,
      type: "keydown"
    }), 2, "onDocumentKeydown"], [onEvent({
      type: "focusin",
      selector: ".rui-tooltip__trigger"
    }), 2, "onFocusIn"], [onEvent({
      type: "focusout",
      selector: ".rui-tooltip__trigger"
    }), 2, "onFocusOut"], [bound, 2, "onPointerEnter"], [bound, 2, "onPointerLeave"]], 0, void 0, RadiantElement));
  }
  content = (_initProto(this), _init_content(this));
  placement = (_init_extra_content(this), _init_placement(this));
  delay = (_init_extra_placement(this), _init_delay(this));
  tooltipTarget = (_init_extra_delay(this), _init_tooltipTarget(this));
  /**
   * Plain (non-reactive) field, not a JSX binding target: `hidden` is toggled
   * imperatively in `setOpen()` rather than bound, since it flips on every
   * hover/focus in/out — high-frequency enough that a plain synchronous DOM
   * write is preferable to routing it through the reactive binding system.
   */
  open = (_init_extra_tooltipTarget(this), false);
  showTimer = null;
  hideTimer = null;
  tooltipId = `rui-tooltip-${Math.random().toString(36).slice(2, 9)}`;
  describedEl = null;
  cleanupFloating = null;
  /**
   * Pointer enter/leave must be host listeners: those events do not bubble, and
   * `@onEvent` only supports delegated (bubbling) listeners.
   */
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener("pointerenter", this.onPointerEnter);
    this.addEventListener("pointerleave", this.onPointerLeave);
    queueMicrotask(() => this.wireTrigger());
  }
  disconnectedCallback() {
    this.clearTimers();
    this.teardownFloating();
    this.removeEventListener("pointerenter", this.onPointerEnter);
    this.removeEventListener("pointerleave", this.onPointerLeave);
    this.describedEl?.removeAttribute("aria-describedby");
    super.disconnectedCallback();
  }
  clearTimers() {
    if (this.showTimer) clearTimeout(this.showTimer);
    if (this.hideTimer) clearTimeout(this.hideTimer);
    this.showTimer = null;
    this.hideTimer = null;
  }
  teardownFloating() {
    this.cleanupFloating?.();
    this.cleanupFloating = null;
  }
  getAnchor() {
    return findFirstFocusableCandidate(this) ?? this;
  }
  wireTrigger() {
    this.describedEl?.removeAttribute("aria-describedby");
    this.describedEl = this.getAnchor();
    if (this.tooltipTarget) this.tooltipTarget.id = this.tooltipId;
    this.describedEl.setAttribute("aria-describedby", this.tooltipId);
  }
  attachFloating() {
    if (!this.tooltipTarget) return;
    this.teardownFloating();
    this.cleanupFloating = attachFloating({
      anchor: this.getAnchor(),
      floating: this.tooltipTarget,
      getPlacement: () => this.placement,
      gap: TOOLTIP_GAP
    });
  }
  onDescribedPropsUpdated() {
    this.wireTrigger();
    if (this.open && this.tooltipTarget) {
      applyFloatingPosition(this.getAnchor(), this.tooltipTarget, this.placement, TOOLTIP_GAP);
    }
  }
  setOpen(next) {
    this.clearTimers();
    this.open = next;
    if (!this.tooltipTarget) return;
    this.tooltipTarget.hidden = !next;
    if (next) this.attachFloating();else this.teardownFloating();
  }
  scheduleShow() {
    this.clearTimers();
    if (this.delay <= 0) {
      this.setOpen(true);
      return;
    }
    this.showTimer = setTimeout(() => this.setOpen(true), this.delay);
  }
  scheduleHide() {
    this.clearTimers();
    this.hideTimer = setTimeout(() => this.setOpen(false), 80);
  }
  onDocumentKeydown(event) {
    if (!this.open || event.key !== "Escape") return;
    this.setOpen(false);
  }
  onFocusIn() {
    this.scheduleShow();
  }
  onFocusOut(event) {
    const next = event.relatedTarget;
    if (next && this.contains(next)) return;
    this.scheduleHide();
  }
  onPointerEnter() {
    this.scheduleShow();
  }
  onPointerLeave() {
    this.scheduleHide();
  }
  render() {
    return /* @__PURE__ */jsxs("span", {
      class: "rui-tooltip",
      children: [/* @__PURE__ */jsx("span", {
        class: "rui-tooltip__trigger",
        children: /* @__PURE__ */jsx("slot", {})
      }), /* @__PURE__ */jsx("span", {
        "data-ref": "tooltip",
        id: this.tooltipId,
        class: "rui-tooltip__content rui-floating",
        role: "tooltip",
        hidden: true,
        children: this.$.content
      })]
    });
  }
  static {
    _initClass();
  }
}
export { _RuiTooltip as RuiTooltip };